<template>
  <div v-if="visible" class="context">
    <div class="example card text-center mb-3">
      <div class="card-body">
        {{ $t('result.context.context-example') }}
        <b>{{ result.example }}</b>
        {{ $t('result.context.previous-list') }}
      </div>
    </div>
    <div v-if="this.$ncsConfig.result.context.documentHeader" class="document-header card mb-3 p-3">
      <ncs-context-document-header :document="result.document" :text="result.match.text"
                                   :elements="result.match.elements" :matches="result.match.matches"/>
    </div>
    <a class="btn btn-primary btn-sm my-3" v-if="before < 20" @click.prevent="before += 10" href="#">
      <i class="fa fa-plus"/>
    </a>
    <ul v-if="result.before.length > 0" class="texts-before list-group">
      <li v-for="text in textsBefore" class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="text.text" :elements="text.elements"
                          :moreElementsBefore="text.more_elements_before"
                          :moreElementsAfter="text.more_elements_after"/>
      </li>
    </ul>
    <ul class="texts-text-match list-group my-3">
      <li class="context-text list-group-item bg-lightblue">
        <ncs-context-text :document="result.document" :text="result.match.text" :elements="result.match.elements"
                          :matches="result.match.matches" :analysis="true"
                          :moreElementsBefore="result.match.more_elements_before"
                          :moreElementsAfter="result.match.more_elements_after"/>
      </li>
    </ul>
    <ul v-if="result.after.length > 0" class="texts-after list-group">
      <li v-for="text in textsAfter" class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="text.text" :elements="text.elements"
                          :moreElementsBefore="text.more_elements_before"
                          :moreElementsAfter="text.more_elements_after"/>
      </li>
    </ul>
    <a class="btn btn-primary btn-sm my-3" v-if="after < 20" @click.prevent="after += 10" href="#">
      <i class="fa fa-plus"/>
    </a>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        before: 2,
        after: 2
      }
    },
    computed: {
      ...mapState({
        visible: s => s.api.resultDisplay === 'context',
        result: s => s.api.result,
      }),
      textsBefore() {
        return this.result.before.slice(-this.before)
      },
      textsAfter() {
        return this.result.after.slice(0, this.after)
      }
    }
  }
</script>
